// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__6H3SK","footerText":"styles_footerText__3KU5J","export":"styles_export__1QpLW","exportButtons":"styles_exportButtons__2BSYp"};